const ACCOUNT_CHROME_HIDE_PATTERNS = [
  /^\/admin(?:\/|$)/i,
  /^\/manager(?:\/|$)/i,
  /^\/dashboard(?:\/|$)/i,
  /^\/tenant(?:\/|$)/i,
  /^\/settings(?:\/|$)/i,
  /^\/profile(?:\/|$)/i,
  /^\/login(?:\/|$)/i,
  /^\/signin(?:\/|$)/i,
  /^\/callback(?:\/|$)/i,
  /^\/auth(?:\/|$)/i,
  /^\/m(?:\/|$)/i,
  /^\/extend(?:\/|$)/i,
  /^\/checkout(?:\/|$)/i,
  /^\/manage-booking(?:\/|$)/i,
  /^\/booking-details(?:\/|$)/i,
  /^\/link-expired(?:\/|$)/i,
  /^\/spot-changes(?:\/|$)/i,
];

export const normalizePathname = (pathname = '') => (
  pathname === '/' ? '/' : String(pathname || '/').replace(/\/+$/, '') || '/'
);

export const shouldShowPublicChrome = (pathname = '') => {
  const normalizedPath = normalizePathname(pathname);
  return !ACCOUNT_CHROME_HIDE_PATTERNS.some((pattern) => pattern.test(normalizedPath));
};

export const shouldUseDarkOverscroll = (pathname = '') => {
  const normalizedPath = normalizePathname(pathname);
  return /^\/my-bookings(?:\/|$)/i.test(normalizedPath);
};
